import React from 'react'
import { CreateAttatchFileFormTestContainer } from '../../containers/Officer/CreateAttatchFileFormTestContainer'
export const CreateAttatchFileFormTestPage = () => {
  return (
    <CreateAttatchFileFormTestContainer />
  )
}
